import { FC } from "react";
import InsertChartOutlinedOutlinedIcon from "@mui/icons-material/InsertChartOutlinedOutlined";
import { PopoverProps } from "@mui/material";
import {
  SourceDataChip,
  SourceDataChipProps,
} from "@/components/pages/dashboard/components/widgets/common/widget-header/source-and-name/SourceDataChip";
import {
  WidgetsViewsHierarchySelect,
  WidgetsViewsHierarchySelectProps,
} from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/widgets-views-hierarchy-select/WidgetsViewsHierarchySelect";
import { WidgetQuickActionTrigger } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/WidgetQuickActionTrigger";
import { useAppAbility } from "@/services/permissions";
import { useAppSelector } from "@/store/hooks";
import { currentDashboardProtectedSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/currentDashboardProtectedSelector";

interface WidgetHeaderChipWithViewsHierarchySelectProps
  extends Omit<WidgetsViewsHierarchySelectProps, "CustomTriggerComponent"> {
  sourceData: Omit<SourceDataChipProps, "icon" | "openIn">;
}

export const WidgetHeaderChipWithViewsHierarchySelect: FC<
  WidgetHeaderChipWithViewsHierarchySelectProps
> = ({ sourceData, selectedItemId, onChange }) => {
  const { cannot } = useAppAbility();
  const canNotEditWidget = cannot("edit", "dashboard");
  const isProtected = useAppSelector(currentDashboardProtectedSelector);

  return (
    <SourceDataChip
      {...sourceData}
      icon={InsertChartOutlinedOutlinedIcon}
      openIn="Billing Explorer"
    >
      {!canNotEditWidget && !isProtected && (
        <WidgetsViewsHierarchySelect
          width={250}
          onChange={onChange}
          PopoverProps={popoverProps}
          selectedItemId={selectedItemId}
          CustomTriggerComponent={WidgetQuickActionTrigger}
        />
      )}
    </SourceDataChip>
  );
};

const popoverProps: Partial<PopoverProps> = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "right",
  },
};
